export const OFFERS = { label: 'Ofertas', value: 'ofertas' };
export const NEW_ARRIVALS = { label: 'Nuevos ingresos', value: 'nuevos-ingresos' };
export const MOST_SELLED = { label: 'Más vendidos', value: 'mas-vendidos' };

export const sectionsArray = [NEW_ARRIVALS, OFFERS, MOST_SELLED];
